var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 99,
    viewBox: "0 0 96 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    filter: "url(#filter0_d_390_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1592 22.4072C17.1592 16.0387 22.3219 10.876 28.6904 10.876H67.1279C73.4965 10.876 78.6592 16.0387 78.6592 22.4072V60.8447C78.6592 67.2133 73.4965 72.376 67.1279 72.376H28.6904C22.3219 72.376 17.1592 67.2133 17.1592 60.8447V22.4072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2217 28.1729C40.2217 31.3571 37.6403 33.9385 34.4561 33.9385C31.2718 33.9385 28.6904 31.3571 28.6904 28.1729C28.6904 24.9886 31.2718 22.4072 34.4561 22.4072C37.6403 22.4072 40.2217 24.9886 40.2217 28.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9423 65.5497C19.3565 66.1355 19.3565 67.0852 19.9423 67.671C20.5281 68.2568 21.4778 68.2568 22.0636 67.671L19.9423 65.5497ZM36.3779 51.2354L37.4386 50.1747C36.8528 49.5889 35.9031 49.5889 35.3173 50.1747L36.3779 51.2354ZM44.0654 58.9229L43.0048 59.9835C43.5906 60.5693 44.5403 60.5693 45.1261 59.9835L44.0654 58.9229ZM61.3623 41.626L62.423 40.5653C61.8372 39.9795 60.8874 39.9795 60.3016 40.5653L61.3623 41.626ZM75.6766 58.0616C76.2624 58.6474 77.2122 58.6474 77.798 58.0616C78.3838 57.4758 78.3838 56.5261 77.798 55.9403L75.6766 58.0616ZM22.0636 67.671L37.4386 52.296L35.3173 50.1747L19.9423 65.5497L22.0636 67.671ZM35.3173 52.296L43.0048 59.9835L45.1261 57.8622L37.4386 50.1747L35.3173 52.296ZM45.1261 59.9835L62.423 42.6866L60.3016 40.5653L43.0048 57.8622L45.1261 59.9835ZM60.3016 42.6866L75.6766 58.0616L77.798 55.9403L62.423 40.5653L60.3016 42.6866ZM28.6904 12.376H67.1279V9.37598H28.6904V12.376ZM77.1592 22.4072V60.8447H80.1592V22.4072H77.1592ZM67.1279 70.876H28.6904V73.876H67.1279V70.876ZM18.6592 60.8447V22.4072H15.6592V60.8447H18.6592ZM28.6904 70.876C23.1503 70.876 18.6592 66.3848 18.6592 60.8447H15.6592C15.6592 68.0417 21.4935 73.876 28.6904 73.876V70.876ZM77.1592 60.8447C77.1592 66.3848 72.668 70.876 67.1279 70.876V73.876C74.3249 73.876 80.1592 68.0417 80.1592 60.8447H77.1592ZM67.1279 12.376C72.668 12.376 77.1592 16.8671 77.1592 22.4072H80.1592C80.1592 15.2103 74.3249 9.37598 67.1279 9.37598V12.376ZM28.6904 9.37598C21.4935 9.37598 15.6592 15.2103 15.6592 22.4072H18.6592C18.6592 16.8671 23.1503 12.376 28.6904 12.376V9.37598ZM38.7217 28.1729C38.7217 30.5287 36.8119 32.4385 34.4561 32.4385V35.4385C38.4687 35.4385 41.7217 32.1855 41.7217 28.1729H38.7217ZM34.4561 32.4385C32.1002 32.4385 30.1904 30.5287 30.1904 28.1729H27.1904C27.1904 32.1855 30.4434 35.4385 34.4561 35.4385V32.4385ZM30.1904 28.1729C30.1904 25.817 32.1002 23.9072 34.4561 23.9072V20.9072C30.4434 20.9072 27.1904 24.1602 27.1904 28.1729H30.1904ZM34.4561 23.9072C36.8119 23.9072 38.7217 25.817 38.7217 28.1729H41.7217C41.7217 24.1602 38.4687 20.9072 34.4561 20.9072V23.9072Z",
    fill: "#6D81B4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_553",
    x: 0.65918,
    y: 4.37598,
    width: 94.5,
    height: 94.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0117647 0 0 0 0 0.156863 0 0 0 0 0.262745 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_553",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.59ab64ad5e2aec6e1fe13d2127142015.svg";
export { ForwardRef as ReactComponent };